import { openNubankDeeplink } from "./nubankHandoff";

const CSAT_SURVEY_DEEPLINK = "nuviagens-survey";

const STORAGE_KEY_PREFIX = "nubank.csat";

export type CsatVertical = "hotels" | "flights";
export type CsatPlatform = "legacy" | "wl";
export type CsatScreen = "booking_confirmation" | "search_screen";

export type CsatSurveyContext = {
  vertical: CsatVertical;
  screen: CsatScreen;
  bookingId?: string;
};

const PLATFORM: CsatPlatform = "legacy";

function storageKey(vertical: CsatVertical): string {
  return `${STORAGE_KEY_PREFIX}.${PLATFORM}.${vertical}`;
}

export function hasShownBookingSurvey(vertical: CsatVertical): boolean {
  try {
    return localStorage.getItem(storageKey(vertical)) === "true";
  } catch {
    return false;
  }
}

export function markBookingSurveyShown(vertical: CsatVertical): void {
  try {
    localStorage.setItem(storageKey(vertical), "true");
  } catch {
    // Ignore storage errors (private mode, quota exceeded)
  }
}

export function openBookingSurveyDeeplink(context: CsatSurveyContext): void {
  openNubankDeeplink({
    deeplink: CSAT_SURVEY_DEEPLINK,
    params: {
      platform: PLATFORM,
      vertical: context.vertical,
      screen: context.screen,
      ...(context.bookingId ? { "booking-id": context.bookingId } : {}),
    },
  });
}

const RESULTS_VIEWED_PREFIX = "nubank.csat.resultsViewed";

export function markResultsViewed(vertical: CsatVertical): void {
  try {
    sessionStorage.setItem(`${RESULTS_VIEWED_PREFIX}.${vertical}`, "true");
  } catch {
    // Ignore storage errors
  }
}

export function hasViewedResults(vertical: CsatVertical): boolean {
  try {
    return (
      sessionStorage.getItem(`${RESULTS_VIEWED_PREFIX}.${vertical}`) === "true"
    );
  } catch {
    return false;
  }
}

/** Clears per-vertical CSAT frequency-cap state (debug / QA). */
export function clearBookingSurveyCompletions(): void {
  try {
    localStorage.removeItem(storageKey("hotels"));
    localStorage.removeItem(storageKey("flights"));
  } catch {
    // Ignore storage errors
  }
}

/** Test helper to reset frequency-cap state. */
export function resetCsatSurveyStateForTests(): void {
  clearBookingSurveyCompletions();
  try {
    sessionStorage.removeItem(`${RESULTS_VIEWED_PREFIX}.hotels`);
    sessionStorage.removeItem(`${RESULTS_VIEWED_PREFIX}.flights`);
  } catch {
    // Ignore storage errors
  }
}
